import leeCoreLex from 'bundles/epic/clients/leeCoreLex';

export function areDailyGoalsEnabled() {
  return leeCoreLex.get('enableDailyGoals');
}
